import React from "react";
import { NO_IMAGE_FOUND } from "../../../actions/Util";

const DashboardTableWidget = ({
  title,
  data = [],
  columns = [],
  onViewMore,
  onRowClick,
  loading = false
}) => {
  // Helper function to get nested property value
  const getNestedValue = (obj, path) => {
    if (!obj || !path) return null;
    
    const parts = path.split(/[.[\]]+/).filter(part => part !== '');
    let value = obj;
    
    for (const part of parts) {
      if (value === null || value === undefined) return null;
      
      const index = Number(part);
      if (!isNaN(index) && Array.isArray(value)) {
        value = value[index];
      } else {
        value = value[part];
      }
    }
    
    return value;
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  };

  const formatCurrency = (value) => {
    const num = formatNumber(value);
    return num.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  };

  const renderCellContent = (row, col) => {
    // If column has a custom render function, use it
    if (col.render && typeof col.render === 'function') {
      return col.render(row);
    }

    const value = getNestedValue(row, col.key);
    
    if (col.type === 'image') {
      return (
        <img
          src={value || NO_IMAGE_FOUND}
          alt=""
          style={{
            width: "50px",
            height: "50px",
            objectFit: "cover",
            borderRadius: "4px"
          }}
        />
      );
    }
    
    if (col.type === 'number') {
      return formatNumber(value);
    }
    
    if (col.type === 'currency') {
      return `$${formatCurrency(value)}`;
    }
    
    return value || '-';
  };

  const getColumnAlignment = (col) => {
    if (col.type === 'number' || col.type === 'currency') {
      return 'right';
    }
    return col.align || 'left';
  };

  const handleRowClick = (row, index) => {
    if (onRowClick) {
      onRowClick(row, index);
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes shimmerMove {
            0% {
              background-position: -200% 0;
            }
            100% {
              background-position: 200% 0;
            }
          }
          
          .clickable-row {
            cursor: pointer;
          }
          
          .clickable-row:hover {
            background-color: #f5f5f5;
          }
        `}
      </style>

      <div className="dashboard-box">
        <div className="dashboard-box-header">
          <div className="dashboard-box-title left">{title}</div>

          <div className="right">
            {onViewMore && (
              <button
                type="button"
                className="btn pull-right btn-flat btn-default"
                onClick={onViewMore}
              >
                View More
              </button>
            )}
          </div>
        </div>

        <div className="dashboard-box-body">
          <div className="table-responsive scroll2">
            {loading ? (
              <table className="table table-striped no-margin">
                <thead>
                  <tr>
                    {columns.map((col, i) => (
                      <th
                        key={i}
                        style={{ textAlign: getColumnAlignment(col) }}
                      >
                        {col.label}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {Array.from({ length: 5 }).map((_, i) => (
                    <tr key={i}>
                      {columns.map((_, j) => (
                        <td key={j}>
                          <div
                            style={{
                              height: "14px",
                              width: "100%",
                              borderRadius: "4px",
                              background:
                                "linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%)",
                              backgroundSize: "200% 100%",
                              animation:
                                "shimmerMove 1.5s ease-in-out infinite"
                            }}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : data && data.length > 0 ? (
              <table className="table table-striped no-margin">
                <thead>
                  <tr>
                    {columns.map((col, i) => (
                      <th
                        key={i}
                        style={{ textAlign: getColumnAlignment(col) }}
                      >
                        {col.label}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {data.map((row, i) => (
                    <tr 
                      key={i}
                      className={onRowClick ? "clickable-row" : ""}
                      onClick={() => handleRowClick(row, i)}
                    >
                      {columns.map((col, j) => (
                        <td
                          key={j}
                          style={{ textAlign: getColumnAlignment(col) }}
                        >
                          {renderCellContent(row, col)}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div
                style={{
                  padding: "15px",
                  textAlign: "center",
                  color: "#999"
                }}
              >
                No records found
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardTableWidget;